import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';

import { getClientEnvironmentDetails } from '@sm/utils';

import { DesktopScreen, MobileTabletScreen, StaticContext } from '@sm/webassets';

import DeveloperWebNavHeaderDesktop from './DeveloperWebNavHeaderDesktop';
import DeveloperWebNavHeaderMobile from './DeveloperWebNavHeaderMobile';

import './developer-web-nav-header.scss';

const navigationItems = location => {
  const items = [
    { target: '/', text: 'Home' },
    { target: '/apps/', text: 'My Apps' },
    { target: '/api/v3/', text: 'Docs' },
    { target: '/tools/api_status/', text: 'Status' },
    { target: '/faq/', text: 'FAQ' },
  ];

  items.forEach(item => {
    const headerItem = item;
    headerItem.class = 'sm-dev-web-nav-header__nav__button';
    if (location.pathname === item.target) {
      headerItem.class = `${item.class} sm-dev-web-nav-header__nav__button--active`;
    }
  });

  return items;
};

const DeveloperWebNavHeader = () => {
  const {
    environment: { domain, subdomain },
    userAgent,
    url,
  } = useContext(StaticContext);
  const { isDesktop } = getClientEnvironmentDetails(userAgent);
  const location = useLocation();

  let redirectUrl = url;
  if (subdomain === 'developer') {
    if (window && window.location) {
      redirectUrl = window.location.href;
    }
  }

  return (
    <>
      <DesktopScreen defaultMatches={isDesktop}>
        <header data-testid="DeveloperWebNavHeader__Desktop">
          <DeveloperWebNavHeaderDesktop navItems={navigationItems(location)} domain={domain} url={redirectUrl} />
        </header>
      </DesktopScreen>
      <MobileTabletScreen defaultMatches={!isDesktop}>
        <header data-testid="DeveloperWebNavHeader__Mobile">
          <DeveloperWebNavHeaderMobile navItems={navigationItems(location)} domain={domain} url={redirectUrl} />
        </header>
      </MobileTabletScreen>
    </>
  );
};

export default DeveloperWebNavHeader;
